/**
 * @generated SignedSource<<976d5e06a5e1ec0e9d9e5abdb0c16ab9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceHeader_space$data = {
  readonly containsExternalCollaborators: boolean;
  readonly currentUser?: {
    readonly isAdmin: boolean;
    readonly isFavourited: boolean;
    readonly isWatched: boolean;
  };
  readonly homepage: {
    readonly id: string | null;
  } | null;
  readonly icon: {
    readonly path: string;
  } | null;
  readonly id: string | null;
  readonly key: string | null;
  readonly name: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly status: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "SpaceHeader_space";
};
export type SpaceHeader_space$key = {
  readonly " $data"?: SpaceHeader_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceHeader_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLicensed"
    }
  ],
  "kind": "Fragment",
  "name": "SpaceHeader_space",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    },
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "condition": "isLicensed",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SpaceUserMetadata",
          "kind": "LinkedField",
          "name": "currentUser",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isAdmin"
            },
            {
              "kind": "ScalarField",
              "name": "isFavourited"
            },
            {
              "kind": "ScalarField",
              "name": "isWatched"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "containsExternalCollaborators"
    }
  ],
  "type": "Space"
};
})();

(node as any).hash = "eedccc77702d6484eacdc7cac611d939";

export default node;
